import React, { useState } from "react";
import { Form, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useProduct } from "../../hooks/useProduct";
import ProductForm from "./ProductForm";

const NewProductModal = (props) => {
  const { account, visible, setVisible, dispatch } = props;

  const { t } = useTranslation();

  const [form] = Form.useForm();

  const { create } = useProduct();

  const [submitting, setSubmitting] = useState(false);

  const handleOk = (e) => {
    form.validateFields().then((values, err) => {
      if (!err) {
        const params = {
          companyId: account.Companies[0].id,
          productName: values.productName,
          internalName: values.internalName,
          shortName: values.shortName,
          weightInGram: values.weightInGram,
          // baseUomId: values.baseUomId,
          // saleUomId: values.saleUomId,
        };
        create(params).then((res) => {
          if (res.status === "success") {
            dispatch({ type: "refresh" });
            setVisible(false);
            form.resetFields();
          }
          setSubmitting(false);
        });
      }
    });
  };

  const handleCancel = () => setVisible(false);

  return (
    <Modal
      title={t("product.addNewTitle")}
      confirmLoading={submitting}
      centered
      visible={visible}
      destroyOnClose
      onCancel={handleCancel}
      onOk={handleOk}
      okText={t("action.submit")}
      cancelText={t("action.cancel")}
    >
      <ProductForm form={form} />
    </Modal>
  );
};

export default NewProductModal;
